import React from 'react';
import { Navigate } from 'react-router-dom';
import { isNativeApp } from '../utils/platform';
import Landing from '../pages/Landing';

// Web/PWA visitors see the marketing Landing page.
// Native app users (App Store / Play Store) already converted, so skip the
// landing and go straight to the app — Dashboard if a session exists, else Auth.
const RootRoute = () => {
  if (isNativeApp()) {
    const hasSession = !!localStorage.getItem('user') || !!localStorage.getItem('token');
    return <Navigate to={hasSession ? '/dashboard' : '/auth'} replace />;
  }
  return <Landing />;
};

export default RootRoute;
